import React, { createContext, useContext, useMemo } from 'react';

type RecipientView = Readonly<{ onLinkClick?: () => void }>;

// Marks a subtree as the card recipient's view. Link layers are only clickable inside it; previews
// elsewhere (editor, review, PDP, gallery) render them inert.
const IsWithinRecipientViewContext = createContext<RecipientView | null>(null);

export const IsWithinRecipientViewProvider = ({ onLinkClick, children }: Readonly<{ onLinkClick?: () => void; children: React.ReactNode }>) => {
  const value = useMemo(() => ({ onLinkClick }), [onLinkClick]);
  return <IsWithinRecipientViewContext.Provider value={value}>{children}</IsWithinRecipientViewContext.Provider>;
};

export const useIsWithinRecipientView = () => useContext(IsWithinRecipientViewContext) !== null;

export const useRecipientViewLinkClick = () => useContext(IsWithinRecipientViewContext)?.onLinkClick;
